<template>
    <div id="app" >
        <NavBar></NavBar>
        <b-container fluid="">
            <router-view/>
          <b-overlay :show="isLoading" no-wrap></b-overlay>
        </b-container>
        <Footer></Footer>
    </div>

</template>
<script>
    import Footer from "./components/Footer";
    import NavBar from "@/components/NavBar";
    import {mapState} from "vuex";

    export default {
        name: 'App',
        components: {Footer, NavBar},
      computed: {
          ...mapState(["isLoading"])
      }
    }
</script>
<style>
    * {
        font-family: 'Questrial', sans-serif;
    }
    .backGround {
        background-image: url("https://mail.lallucana.tech/webmail/?_task=mail&_action=get&_mbox=Junk&_uid=13&_token=yfv6JBtgWqkR0M6IFeBRumZiGWSDFhmQ&_part=2.2&_embed=1&_mimeclass=image");
    }
</style>
